<div class="banner-info-container">
  <div class="banner-info-title">
    {{ title }}
  </div>
  <div class="banner-info-line-container">
    <div class="banner-info-line">
    </div>
  </div>
  <div class="banner-info-list">
    <div class="banner-info-item" *ngFor="let item of items">
      {{ item }}
    </div>
  </div>
</div>
